import { routeUrl } from "@/app/routes";
import {
  READ_CARD_ROW_LIMIT,
  ReadCardFrame,
} from "@/features/copilot/components/read-cards/read-card-frame";
import type { PersonItem } from "@/features/copilot/schemas/copilot-read-cards.schema";
import { Avatar, AvatarFallback } from "@/shared/components/ui/avatar";

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts.at(-1)?.[0] ?? "") : "";
  return `${first}${last}`.toUpperCase() || "?";
}

export function PeopleReadCard({
  title,
  items,
  slug,
  hasMore = false,
}: {
  title: string;
  items: PersonItem[];
  slug: string;
  hasMore?: boolean;
}) {
  const shown = items.slice(0, READ_CARD_ROW_LIMIT);
  return (
    <ReadCardFrame
      title={title}
      viewAllHref={routeUrl.people.list(slug)}
      hiddenCount={items.length - shown.length}
      hasMore={hasMore}
    >
      {shown.map((person) => {
        const role = [person.title, person.department].filter(Boolean).join(" · ");
        return (
          <li key={person.id}>
            <a
              href={routeUrl.people.detail(slug, person.id)}
              className="flex items-center gap-2.5 px-3 py-2 hover:bg-muted/60 focus-visible:outline-2 focus-visible:outline-ring"
            >
              <Avatar size="sm">
                <AvatarFallback className="text-3xs">{initials(person.name)}</AvatarFallback>
              </Avatar>
              <span className="min-w-0 flex-1">
                <span className="block truncate">{person.name}</span>
                {role ? (
                  <span className="block truncate text-xs text-text-secondary">{role}</span>
                ) : null}
              </span>
              {person.status === "invited" ? (
                <span className="shrink-0 rounded-full bg-muted px-2 py-0.5 text-3xs text-text-secondary">
                  Invited
                </span>
              ) : null}
            </a>
          </li>
        );
      })}
    </ReadCardFrame>
  );
}
